import React, { useState, useEffect } from 'react';
import '../styles/Inquiries.css';

export default function Inquiries() {
  const [inquiries, setInquiries] = useState([]);
  const [filter, setFilter] = useState('pending');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const q = filter === 'all' ? '' : `?status=${filter}`;
      const res = await fetch(`/api/inquiries${q}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setInquiries(data.inquiries || []);
      } else {
        setError('Failed to load inquiries');
      }
    } catch (err) {
      setError('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const act = async (id, action) => {
    const verb = action === 'confirm' ? 'Confirm this inquiry (dates stay blocked)?' : 'Reject this inquiry and free the dates?';
    if (!window.confirm(verb)) return;
    setBusyId(id);
    try {
      const res = await fetch(`/api/inquiries/${id}/${action}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        load();
      } else {
        const err = await res.json();
        alert('Error: ' + (err.error || 'Action failed'));
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setBusyId(null);
    }
  };

  const fmt = (d) => new Date(d).toLocaleDateString();
  const fmtDateTime = (d) => new Date(d).toLocaleString();

  const statusBadge = (s) => <span className={`inq-badge inq-${s}`}>{s}</span>;

  if (loading) return <div style={{ padding: '20px' }}>Loading inquiries…</div>;

  return (
    <div className="inquiries">
      <h2>Booking Inquiries</h2>
      <p>Guest inquiries from the public site. Confirming keeps the dates blocked; rejecting frees them.</p>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="inq-filters">
        {['pending', 'confirmed', 'rejected', 'all'].map(f => (
          <button key={f} className={`inq-filter ${filter === f ? 'active' : ''}`} onClick={() => setFilter(f)}>
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      {inquiries.length === 0 ? (
        <p className="inq-empty">No {filter === 'all' ? '' : filter} inquiries.</p>
      ) : (
        <div className="inq-list">
          {inquiries.map(inq => (
            <div key={inq.id} className={`inq-card ${inq.over_capacity ? 'inq-over' : ''}`}>
              <div className="inq-head">
                <div className="inq-name">{inq.guest_name} {statusBadge(inq.status)}</div>
                <div className="inq-when">{fmtDateTime(inq.created_at)}</div>
              </div>

              <div className="inq-grid">
                <div><span>Dates</span>{fmt(inq.check_in)} → {fmt(inq.check_out)}</div>
                <div><span>Guests</span>{inq.num_guests}{inq.over_capacity ? ' ⚠️ over capacity' : ''}</div>
                <div><span>Phone</span>{inq.guest_phone}{inq.prefers_whatsapp ? ' (WhatsApp)' : ''}</div>
                {inq.decided_by && <div><span>Decided by</span>{inq.decided_by}</div>}
              </div>

              {inq.notes && <div className="inq-notes"><span>Notes:</span> {inq.notes}</div>}

              <div className="inq-actions">
                <a className="inq-wa" href={inq.whatsappLink} target="_blank" rel="noopener noreferrer">
                  💬 WhatsApp guest
                </a>
                {inq.status === 'pending' && (
                  <>
                    <button className="inq-confirm" disabled={busyId === inq.id} onClick={() => act(inq.id, 'confirm')}>
                      {busyId === inq.id ? '…' : 'Confirm'}
                    </button>
                    <button className="inq-reject" disabled={busyId === inq.id} onClick={() => act(inq.id, 'reject')}>
                      {busyId === inq.id ? '…' : 'Reject'}
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
